import React from 'react'
import './About.css'

const Skill = (props) => {
    return(<div className="skill-item">{props.skill}</div>)
}

export default Skill;